import Image from "next/image";
import GlobalImageComponent from "../Comman/GlobalImageComponent";

const FooterQRCodeSection = () => {
  return (
    <div className="lg:max-w-60.75 w-full lg:mt-0 mt-10">
      <h3 className="text-xl font-bold text-text1">Scan QR Code</h3>

      <figure className="h-68.5 mt-6 size-fit mx-auto">
        <GlobalImageComponent
          alt="QR Code"
          loading="lazy"
          width={243}
          height={274}
          className="object-contain"
          // src="https://www.baghaffiliates.xyz/_next/image?url=%2Fhome%2Fqr.png&w=256&q=75"
          src="/assets/DALAL Affiliate QR.png"
        />
      </figure>
    </div>
  );
};

export default FooterQRCodeSection;
